// extracted by mini-css-extract-plugin
export default {"amount-box":"styles__amount-box__WsJV0","amountBox":"styles__amount-box__WsJV0","negative-amount":"styles__negative-amount__t85e4","negativeAmount":"styles__negative-amount__t85e4"};